<template>
  <v-dialog v-model="getModalCadastroProduto" persistent fullscreen>
    <v-card outlined :loading="$store.getters.getOverlay">
      <v-card-title> Cadastro de Produto </v-card-title>
      <v-card-title>
        <v-flex xs12>
          <v-tabs app grow v-model="tabs" class="hidden-sm-and-down">
            <v-tab>
              <span>GERAL</span>
            </v-tab>

            <v-tab v-if="$helper.verificaPermissao('alterar-preco-venda-produto')">
              <span>PREÇO DE VENDA</span>
            </v-tab>

            <v-tab v-if="$helper.verificaPermissao('alterar-informacoes-fiscais-produto')">
              <span>INFORMAÇÕES FISCAIS</span>
            </v-tab>
            <v-tab v-if="$helper.verificaPermissao('visualizar-grade-produto')" :disabled="!getProduto.id">
              <span>GRADES</span>
            </v-tab>
          </v-tabs>
        </v-flex>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-flex xs12>
          <v-tabs-items v-model="tabs" class="pa-8">
            <!-- informações gerais -->
            <v-tab-item>
              <v-layout row wrap>
                <v-flex xs12 md2>
                  <v-row justify="space-around" class="ml-3 mr-3 mb-3">
                    <v-img
                      :src="$urlApp + '/produtos/sem_imagem.jpg'"
                      aspect-ratio="1.4"
                      @click="modalFotoProduto = true"
                      contain
                      v-if="!getFotoProduto"
                    ></v-img>
                    <v-img
                      :src="getFotoProduto"
                      aspect-ratio="1.4"
                      @click="modalFotoProduto = true"
                      contain
                      v-if="getFotoProduto"
                    ></v-img>
                  </v-row>
                </v-flex>
                <v-flex xs12 md10>
                  <v-layout row wrap class="pa-0 ma-0">
                  <v-flex xs1>
                    <v-text-field
                      label="Código"
                      outlined
                      dense
                      v-model="getProduto.id"
                      readonly
                      class="ml-3 mr-3"
                    ></v-text-field>
                  </v-flex>
                    <v-flex xs12 md11>
                      <v-select
                        :items="getTiposProduto"
                        v-model="getProduto.tipo"
                        outlined
                        dense
                        class="ml-3 mr-3"
                        required
                        label="Tipo"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 md12>
                      <v-text-field
                        dense
                        outlined
                        v-model="getProduto.descricao"
                        label="Descrição"
                        :rules="rules.descricao"
                        class="ml-3 mr-3"
                      >
                      </v-text-field>
                    </v-flex>
                    <!-- <v-flex xs12 md3>
                      <v-checkbox
                        v-model="getProduto.tanque"
                        label="Este produto é uma piscina?"
                      >
                      </v-checkbox>
                    </v-flex> -->
                    <v-flex xs12 md6 v-if="getProduto.tipo == 'PRODUTO'">
                      <v-text-field
                        dense
                        outlined
                        v-model="getProduto.codigo_barra"
                        label="Código de Barras"
                        class="ml-3 mr-3"
                        v-mask="'#############'"
                        @click="$event.target.select()"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 md6 v-if="getProduto.tipo == 'PRODUTO'">
                      <v-autocomplete
                        dense
                        label="Marca"
                        :items="getMarcas"
                        item-text="marca"
                        item-value="marca"
                        v-model="getProduto.marca"
                        outlined
                        append-outer-icon="control_point"
                        @click:append-outer="cadastrarMarca"
                        class="ml-3 mr-3"
                      >
                      </v-autocomplete>
                      <!-- <v-text-field outlined v-model="getProduto.marca" label="Marca"></v-text-field>	 -->
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 md2 v-if="getProduto.tipo == 'PRODUTO'">
                  <v-select
                    dense
                    :items="unidades"
                    item-text="unidade"
                    item-value="unidade"
                    label="UN. Medida"
                    v-model="getProduto.unidade"
                    outlined
                    append-outer-icon="control_point"
                    @click:append-outer="cadastrarUnidade"
                    class="ml-3 mr-3"
                  ></v-select>
                </v-flex>
                <!-- <v-flex xs12 md4>
                                <v-text-field dense outlined v-model="getProduto.referencia" label="Referência" class="ml-3 mr-3"></v-text-field>
                            </v-flex> -->
                <v-flex xs12 md5 v-if="getProduto.tipo == 'PRODUTO'">
                  <v-autocomplete
                    dense
                    :items="getSecoesProduto"
                    item-text="secao"
                    item-value="id"
                    label="Departamento"
                    outlined
                    v-model="getProduto.secao_id"
                    append-outer-icon="control_point"
                    @click:append-outer="cadastrarSecaoProduto"
                    class="ml-3 mr-3"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 md5 v-if="getProduto.tipo == 'PRODUTO'">
                  <v-autocomplete
                    dense
                    :items="getGruposProduto"
                    item-text="grupo"
                    item-value="id"
                    label="Grupo"
                    v-model="getProduto.grupo_id"
                    outlined
                    append-outer-icon="control_point"
                    @click:append-outer="cadastrarGrupoProduto"
                    class="ml-3 mr-3"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 md3 v-if="getProduto.tipo == 'PRODUTO'">
                  <v-autocomplete
                    dense
                    outlined
                    v-model="getProduto.fabricante"
                    label="Fabricante"
                    :items="getFabricantes"
                    item-text="nome"
                    item-value="nome"
                    class="ml-3 mr-3"
                    append-outer-icon="control_point"
                    @click:append-outer="cadastrarFabricante"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 md3 v-if="getProduto.tipo == 'PRODUTO'">
                  <v-text-field
                    dense
                    outlined
                    v-model="getProduto.referencia_fabrica"
                    label="Referência de Fábrica"
                    class="ml-3 mr-3"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3 v-if="getProduto.tipo == 'PRODUTO'">
                  <v-text-field
                    dense
                    outlined
                    v-model="getProduto.codigo_fabrica"
                    label="Código de Fábrica"
                    class="ml-3 mr-3"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3 v-if="getProduto.tipo == 'PRODUTO'">
                  <v-text-field
                    type="date"
                    dense
                    outlined
                    v-model="getProduto.data_validade"
                    label="Data Validade"
                    class="ml-3 mr-3"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4 v-if="getProduto.tipo == 'PRODUTO'">
                  <v-text-field
                    dense
                    outlined
                    v-model="getProduto.estoque_minimo"
                    label="Estoque Mínimo"
                    v-mask="['#,###', '##,###', '###,###']"
                    @click="$event.target.select()"
                    class="ml-3 mr-3"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md2 v-if="getProduto.tipo == 'PRODUTO'">
                  <v-text-field
                    dense
                    outlined
                    v-model="getProduto.altura"
                    label="Altura MT"
                    v-mask="['#,##', '##,##']"
                    @click="$event.target.select()"
                    class="ml-3 mr-3"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md2 v-if="getProduto.tipo == 'PRODUTO'">
                  <v-text-field
                    dense
                    outlined
                    v-model="getProduto.largura"
                    label="Largura MT"
                    v-mask="['#,##', '##,##']"
                    @click="$event.target.select()"
                    class="ml-3 mr-3"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md2 v-if="getProduto.tipo == 'PRODUTO'">
                  <v-text-field
                    dense
                    outlined
                    v-model="getProduto.profundidade"
                    label="Profundidade MT"
                    v-mask="['#,##', '##,##']"
                    @click="$event.target.select()"
                    class="ml-3 mr-3"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md2 v-if="getProduto.tipo == 'PRODUTO'">
                  <v-text-field
                    dense
                    outlined
                    v-model="getProduto.capacidade_litro"
                    label="Capacidade Litro"
                    v-mask="['#.###', '##.###', '###.###']"
                    @click="$event.target.select()"
                    class="ml-3 mr-3"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6 v-if="getProduto.tipo == 'PRODUTO'">
                  <v-text-field
                    dense
                    outlined
                    v-model="getProduto.peso_liquido"
                    label="Peso Líquido"
                    v-mask="['#,###', '##,###', '###,###']"
                    @click="$event.target.select()"
                    class="ml-3 mr-3"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6 v-if="getProduto.tipo == 'PRODUTO'">
                  <v-text-field
                    dense
                    outlined
                    v-model="getProduto.peso_bruto"
                    label="Peso Bruto"
                    v-mask="['#,###', '##,###', '###,###']"
                    @click="$event.target.select()"
                    class="ml-3 mr-3"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12 v-if="getProduto.tipo == 'SERVIÇO'">
                  <v-textarea
                    dense
                    label="Descrição do Serviço"
                    v-model="getProduto.descricao_servico"
                    outlined
                    class="ml-3 mr-3"
                  >
                  </v-textarea>
                </v-flex>
                <v-flex
                  xs12
                  md12
                  v-if="getProduto.tipo == 'PRODUTO' && getProduto.id"
                  class="ml-3 mr-3"
                >
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Estoque</th>
                          <th class="text-left">Quantidade</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="e in getProduto.estoques" :key="e.id">
                          <td>{{ e.estoque.nome }}</td>
                          <td>
                            {{ $helper.formatReal(parseFloat(e.quantidade)) }}
                          </td>
                        </tr>
                        <tr>
                          <td>RESERVADO</td>
                          <td v-if="getProduto.reserva.length > 0">
                            {{
                              $helper.formatReal(
                                parseFloat(getProduto.reserva[0].quantidade)
                              )
                            }}
                          </td>
                          <td v-else>0</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <!-- informações gerais -->

            <!-- preço de venda -->
            <v-tab-item>
              <v-layout row wrap>
                <v-flex xs12 md4>
                  <v-text-field
                    dense
                    type="text"
                    outlined
                    v-model="getProduto.preco_custo"
                    label="Preço de Custo"
                    prefix="R$"
                    :rules="rules.preco_custo"
                    class="ml-3 mr-3"
                    v-mask="[
                      '#,##',
                      '##,##',
                      '###,###',
                      '#.###,##',
                      '##.###,##',
                      '###.###,##',
                    ]"
                    @click="$event.target.select()"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    dense
                    type="text"
                    outlined
                    v-model="getProduto.preco_venda"
                    label="Preço de Venda"
                    :rules="rules.preco_venda"
                    class="ml-3 mr-3"
                    prefix="R$"
                    id="preco_venda"
                    v-mask="[
                      '#,##',
                      '##,##',
                      '###,###',
                      '#.###,##',
                      '##.###,##',
                      '###.###,##',
                    ]"
                    @click="$event.target.select()"
                    @blur="obterMargemLucro"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    dense
                    type="text"
                    outlined
                    v-model="getProduto.margem_lucro"
                    @blur="margemLucro"
                    label="Margem de Lucro %"
                    prefix="%"
                    :rules="rules.margem_lucro"
                    @click="$event.target.select()"
                    class="ml-3 mr-3"
                    v-mask="[
                      '#,##',
                      '##,##',
                      '###,###',
                      '#.###,##',
                      '##.###,##',
                      '###.###,##',
                    ]"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    dense
                    type="text"
                    outlined
                    v-model="getProduto.comissao"
                    label="Comissão"
                    prefix="%"
                    :rules="rules.comissao"
                    append-icon="mdi-calculator"
                    @click:append="calcComissao()"
                    @keyup.enter="calcComissao()"
                    @input="calcComissao()"
                    class="ml-3 mr-3"
                    v-mask="[
                      '#,##',
                      '##,##',
                      '###,###',
                      '#.###,##',
                      '##.###,##',
                      '###.###,##',
                    ]"
                    @click="$event.target.select()"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    dense
                    outlined
                    v-model="getProduto.comissao_real"
                    append-icon="mdi-calculator"
                    label="Comissão Calculada"
                    prefix="R$"
                    @click="$event.target.select()"
                    :rules="rules.comissao"
                    class="ml-3 mr-3"
                    v-mask="['#,##', '##,##', '###,##']"
                    disabled
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    dense
                    type="text"
                    outlined
                    v-model="getProduto.desconto_maximo"
                    prefix="%"
                    label="Desconto Máximo Permitido %"
                    @click="$event.target.select()"
                    :rules="rules.desconto_maximo"
                    class="ml-3 mr-3"
                    v-mask="[
                      '#,##',
                      '##,##',
                      '###,###',
                      '#.###,##',
                      '##.###,##',
                      '###.###,##',
                    ]"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <!-- preco de venda -->

            <!-- informações fiscais -->
            <v-tab-item>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-text-field
                    dense
                    outlined
                    v-model="getProduto.ncm"
                    v-mask="'########'"
                    @click="$event.target.select()"
                    label="Código NCM"
                    :rules="rules.ncm"
                    class="ml-3 mr-3"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    dense
                    outlined
                    v-model="getProduto.cest"
                    v-mask="'#######'"
                    @click="$event.target.select()"
                    label="Código CEST"
                    class="ml-3 mr-3"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    dense
                    outlined
                    v-model="getProduto.cfop"
                    v-mask="'#.###'"
                    @click="$event.target.select()"
                    label="CFOP"
                    :rules="rules.cfop"
                    class="ml-3 mr-3"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    dense
                    outlined
                    v-model="getProduto.cfop_fora_estado"
                    v-mask="'#.###'"
                    @click="$event.target.select()"
                    label="CFOP fora do Estado"
                    class="ml-3 mr-3"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-autocomplete
                    dense
                    :items="CSTCsosn"
                    item-text="DESC"
                    item-value="COD"
                    label="CST/CSOSN"
                    v-model="getProduto.cst_csosn"
                    outlined
                    class="ml-3 mr-3"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 md6>
                  <v-autocomplete
                    dense
                    :items="CSTPisCofins"
                    item-text="DESC"
                    item-value="COD"
                    label="CST PIS"
                    v-model="getProduto.cst_pis"
                    outlined
                    class="ml-3 mr-3"
                  >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12 md6>
                  <v-autocomplete
                    dense
                    :items="CSTPisCofins"
                    item-text="DESC"
                    item-value="COD"
                    label="CST COFINS"
                    v-model="getProduto.cst_confins"
                    outlined
                    class="ml-3 mr-3"
                  >
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12 md6>
                  <v-autocomplete
                    dense
                    :items="CSTIpi"
                    item-text="DESC"
                    item-value="COD"
                    label="CST IPI"
                    v-model="getProduto.cst_ipi"
                    outlined
                    class="ml-3 mr-3"
                  >
                  </v-autocomplete>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <!-- informações -->

            <!-- grades --> 
            <v-tab-item>
              <ListarGradeProduto :botaoCadastro="true" :botaoVisualizar="true" :listarGrades="true"/>
            </v-tab-item>
            <!-- grades -->
          </v-tabs-items>
        </v-flex>
      </v-card-text>

      <v-card-actions>
        <v-btn
          outlined
          v-if="getProduto.id && $helper.verificaPermissao('cadastrar-produto')"
          color="primary"
          @click="cadastrarProduto"
          >Novo</v-btn
        >

        <v-btn
          outlined
          v-if="getProduto.id"
          color="default"
          @click="setModalClonarProduto(true)"
          >Clonar</v-btn
        >

        <v-btn
          outlined
          v-if="getProduto.id && $helper.verificaPermissao('excluir-produto')"
          color="error"
          @click="setModalExcluirProduto(true)"
          >Excluir</v-btn
        >
        <v-btn
          outlined
          color="default"
          @click="
            $store.dispatch('ativaModalConfirmacao', {
              mensagem:
                'Você perderá os dados que já preencheu caso não tenha salvo, deseja realmente voltar?',
              action: 'setModalCadastroProduto',
              action_value: false,
            })
          "
          >Voltar</v-btn
        >

        <v-spacer></v-spacer>
        <v-btn
          outlined
          color="success"
          @click="salvar"
          :loading="$store.getters.getOverlay"
          v-if="
            $helper.verificaPermissao('cadastrar-produto') ||
            $helper.verificaPermissao('atualizar-produto')
          "
          >Salvar</v-btn
        >
        <v-menu
          bottom
          left
          transition="slide-y-transition"
          class="ml-10 mr-10"
          v-if="getProduto.tipo != 'SERVIÇO'"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              @click="cadastrarTransferenciaEstoque"
              v-if="
                $helper.verificaPermissao('cadastrar-transferencia-estoque')
              "
            >
              <v-list-item-action>
                <v-icon>compare_arrows</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Transferir Estoque</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              @click="setModalMovimentacaoEstoque(true)"
              v-if="$helper.verificaPermissao('movimentar-estoque-produto')"
            >
              <v-list-item-action>
                <v-icon>swap_vert</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Movimentar Estoque</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- <v-list-item
              @click="modalBaixaReserva = true"
              v-if="$helper.verificaPermissao('baixar-reserva-produto')"
            >
              <v-list-item-action>
                <v-icon>done_all</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Baixar Reserva</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
          </v-list>
        </v-menu>
        <!-- <v-btn color="warning" outlined @click="cadastrarTransferenciaEstoque" v-if="getProduto.id">
                        Transferir
                        Estoque</v-btn>
                    <v-btn color="default" @click="modalBaixaReserva = true" outlined
                        v-if="getProduto.id && getProduto.reserva.length > 0 && getProduto.reserva[0].quantidade > 0">
                        Baixar
                        Reserva</v-btn>
                    <v-btn color="default" @click="setModalMovimentacaoEstoque(true)" outlined>Estoque</v-btn> -->
        <v-switch
          v-model="getProduto.habilitado"
          class="mx-2"
          label="Habilitar/Desabilitar"
          color="success"
          @click="habilitarDesabilitarProduto(getProduto)"
        ></v-switch>
      </v-card-actions>
    </v-card>
    <ModalCadastroMarca />

    <v-dialog v-model="modalCadastrarUniadades" max-width="720">
      <v-card>
        <v-card-title>Cadastro de Unidade de Medida</v-card-title>
        <v-form class="px-3" ref="formUnidadeMedida">
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 md12>
                <v-text-field
                  class="mr-2 ml-2"
                  dense
                  outlined
                  v-model="unidade.unidade"
                  label="Unidade de Medida"
                  :rules="rules.unidade"
                  required
                  @keyup.13="salvarUnidade"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn
              outlined
              color="default"
              @click="modalCadastrarUniadades = false"
              >Voltar</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn outlined color="success" @click="salvarUnidade" type="submit"
              >Salvar</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modalFotoProduto" max-width="720">
      <v-card :loading="$store.getters.getOverlay">
        <v-card-title>Foto</v-card-title>
        <v-form class="px-3" ref="formFotoProduto">
          <v-card-text>
            <v-img
              :src="getFotoProduto"
              v-if="getFotoProduto"
              aspect-ratio="2.6"
              contain
            ></v-img>
            <br />
            <v-file-input
              dense
              outlined
              v-if="showInputFotoProduto"
              label="Foto"
              @change="selecionaFoto"
              required
              :rules="rules.foto"
            >
            </v-file-input>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="default"
              @click="modalFotoProduto = false"
              :loading="$store.getters.getOverlay"
              outlined
              >Voltar</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="success"
              @click="salvarFotoProduto"
              outlined
              v-if="getProduto.id"
              :loading="$store.getters.getOverlay"
              >Salvar</v-btn
            >
            <v-btn
              color="success"
              @click="modalFotoProduto = false"
              outlined
              v-if="!getProduto.id"
              >Salvar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modalBaixaReserva" max-width="720">
      <v-card :loading="$store.getters.getOverlay">
        <v-card-title>Baixar Reserva</v-card-title>
        <v-form class="px-3">
          <v-card-text>
            <h3 align="center">Tem certeza que deseja dar baixa?</h3>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="default"
              @click="modalBaixaReserva = false"
              :loading="$store.getters.getOverlay"
              outlined
              >Voltar</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="success"
              @click="baixarReserva"
              outlined
              :loading="$store.getters.getOverlay"
              >Sim
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <ModalCadastroGrupo />
    <ModalCadastroSecao />
    <ModalExcluirProduto />
    <ModalTransferenciaEstoque />
    <ModalMovimentacaoEstoque />
    <ModalCadastroFabricante />
    <ModalClonarProduto />
  </v-dialog>
</template>

<script>
import Unidade from "@/services/UnidadeMedidaService";
import CSTService from "@/services/CSTService";
import { mapActions, mapGetters } from "vuex";
import ModalCadastroMarca from "@/pages/marca/ModalCadastro";
import ModalCadastroGrupo from "@/pages/produto/grupo/ModalCadastro";
import ModalCadastroSecao from "@/pages/produto/secao/ModalCadastro";
import ModalExcluirProduto from "@/pages/produto/ModalExcluir";
import ProdutoService from "@/services/ProdutoService";
import ModalTransferenciaEstoque from "@/pages/estoque/transferencia/ModalCadastro";
import ModalMovimentacaoEstoque from "@/pages/estoque/ModalMovimentacaoEstoque";
import ModalCadastroFabricante from "@/pages/fabricante/ModalCadastro";
import ListarGradeProduto from "@/pages/produto/grade/Listar"
import ModalClonarProduto from "@/pages/produto/ModalClonar"
const _ = require("lodash");

export default {
  components: {
    ModalCadastroMarca,
    ModalCadastroGrupo,
    ModalCadastroSecao,
    ModalExcluirProduto,
    ModalTransferenciaEstoque,
    ModalMovimentacaoEstoque,
    ModalCadastroFabricante,
    ListarGradeProduto,
    ModalClonarProduto,
  },
  data() {
    return {
      unidade: {
        unidade: "",
      },
      comissao_real: "0,00",
      unidades: [],
      modalCadastrarUniadades: false,
      CST: [],
      CSTPisCofins: [],
      CSTIpi: [],
      CSTCsosn: [],
      rules: {
        descricao: [(v) => !!v || "Campo obrigatório."],
        unidade: [(v) => !!v || "Campo obrigatório."],
        marca: [(v) => !!v || "Campo obrigatório."],
        grupo: [(v) => !!v || "Campo obrigatório."],
        secao: [(v) => !!v || "Campo obrigatório."],
        preco_venda: [(v) => !!v || "Campo obrigatório."],
        ncm: [(v) => !!v || "Campo obrigatório."],
        cest: [(v) => !!v || "Campo obrigatório."],
        cfop: [(v) => !!v || "Campo obrigatório."],
        foto: [(v) => !!v || "Selecione uma imagem."],
      },
      tabs: 0,
      modalFotoProduto: false,
      showInputFotoProduto: true,
      atualizarFoto: false,
      foto: null,
      modalBaixaReserva: false,
    };
  },
  watch: {
    getModalCadastroProduto() {
      if (this.getModalCadastroProduto) {
        document.addEventListener("keydown", this.keyUp);
        this.calcComissao("getPercent");
      } else {
        document.removeEventListener("keydown", this.keyUp);
      }
    },
  },
  computed: {
    ...mapGetters([
      "getProduto",
      "getModalExcluirProduto",
      "getModalCadastroMarca",
      "getMarcas",
      "getGruposProduto",
      "getSecoesProduto",
      "getModalCadastroProduto",
      "getTiposProduto",
      "getFotoProduto",
      "getFabricantes",
    ]),
  },

  methods: {
    ...mapActions([
      "cadastrarProduto",
      "setModalCadastroProduto",
      "salvarProduto",
      "atualizarProduto",
      "visualizarProduto",
      "excluirProduto",
      "listarMarcas",
      "cadastrarMarca",
      "cadastrarGrupoProduto",
      "listarGruposProduto",
      "cadastrarSecaoProduto",
      "listarSecoesProduto",
      "setModalExcluirProduto",
      "habilitarDesabilitarProduto",
      "cadastrarTransferenciaEstoque",
      "baixarReservaProduto",
      "setModalMovimentacaoEstoque",
      "listarFabricantes",
      "cadastrarFabricante",
      "ativaModalConfirmacao",
      "setModalClonarProduto",
    ]),
    salvar() {
      if (this.getProduto.id) {
        this.atualizarProduto(this.getProduto);
      } else {
        this.salvarProduto(this.getProduto).then((res) => {
          if (this.getProduto.id) {
            this.salvarFotoProduto();
          }
        });
      }
    },

    calcComissao() {
      const calc =
        (this.$helper.cleanFormatReal(this.getProduto.comissao) / 100) *
        this.$helper.cleanFormatReal(this.getProduto.preco_venda);
      this.getProduto.comissao_real = isNaN(calc)
        ? "0,00"
        : this.$helper.formatReal(calc);
    },
    selecionaFoto(e) {
      this.foto = e;
      this.atualizarFoto = true;
    },
    salvarFotoProduto() {
      if (this.$refs.formFotoProduto.validate()) {
        this.$store.commit("setOverlay", true);
        let form = new FormData();
        form.append("foto", this.foto);
        ProdutoService.salvarFoto(form, this.getProduto.id)
          .then((res) => {
            this.$store.commit("setOverlay", false);
            this.$store.commit("setFotoProduto", res.data.foto);
            this.showInputFotoProduto = false;
            this.$nextTick(() => {
              this.showInputFotoProduto = true;
            });
            this.atualizarFoto = false;
            this.modalFotoProduto = false;
          })
          .catch((e) => {
            this.$store.commit("setOverlay", false);
            console.log(e);
          });
      }
    },
    //Unidades
    listarUnidades() {
      Unidade.listar()
        .then((res) => {
          this.unidades = res.data;
        })
        .catch((e) => console.log(e));
    },
    cadastrarUnidade() {
      this.modalCadastrarUniadades = true;
    },
    salvarUnidade() {
      if (this.$refs.formUnidadeMedida.validate()) {
        Unidade.salvar(this.unidade)
          .then((res) => {
            this.modalCadastrarUniadades = false;
            this.listarUnidades();
            this.$store.commit(
              "snackbarSuccess",
              "Unidade de medida cadastrada."
            );
            this.unidade = {};
          })
          .catch((e) => console.log(e));
      }
    },

    margemLucro() {

      if(!this.getProduto.preco_custo || !this.getProduto.preco_venda || this.getProduto.preco_custo == '0,00'){
        return
      } 
        

      let preco_custo = parseFloat(
        this.getProduto.preco_custo
          .toString()
          .replace(".", "")
          .replace(",", ".")
      );
      let preco_venda = parseFloat(
        this.getProduto.preco_venda
          .toString()
          .replace(".", "")
          .replace(",", ".")
      );
      let margem_lucro = parseFloat(
        this.getProduto.margem_lucro
          .toString()
          .replace(".", "")
          .replace(",", ".")
      );

      this.getProduto.preco_venda = this.$helper.formatReal(
        parseFloat(preco_custo + (margem_lucro / 100) * preco_custo)
      );
    },
    obterMargemLucro() {
      console.log(this.getProduto)
      if(!this.getProduto.preco_custo || !this.getProduto.preco_venda){
        return
      } 

      let preco_custo = parseFloat(
        this.getProduto.preco_custo
          .toString()
          .replace(".", "")
          .replace(",", ".")
      );
      let preco_venda = parseFloat(
        this.getProduto.preco_venda
          .toString()
          .replace(".", "")
          .replace(",", ".")
      );
      let percentualLucro = (preco_venda / preco_custo - 1) * 100;

      if (preco_custo == 0) {
        this.getProduto.margem_lucro = this.$helper.formatReal(0);
        return;
      }

      this.getProduto.margem_lucro = this.$helper.formatReal(percentualLucro);
    },

    listarCST() {
      CSTService.listarCST()
        .then((res) => {
          this.CST = res.data;
          // console.log('listando CST: ',res.data)
        })
        .catch((e) => console.log(e));

      CSTService.listarCST_PIS_CONFIS()
        .then((res) => (this.CSTPisCofins = res.data))
        .catch((e) => console.log(e));

      CSTService.listarCST_IPI()
        .then((res) => (this.CSTIpi = res.data))
        .catch((e) => console.log(e));
      
      CSTService.listarCST_CSOSN()
      .then(res => {
        this.CSTCsosn = res.data
      })
      .catch(e => console.log(e))
    },
    baixarReserva() {
      this.modalBaixaReserva = false;
      this.baixarReservaProduto(this.getProduto.id);
    },
    keyUp(e) {
      if (!e) e = window.event;
      let keyCode = e.keyCode || e.which;

      if (keyCode == 27) {
        this.ativaModalConfirmacao({
          aberto: true,
          icone: "warning",
          cor: "yellow darken-3",
          mensagem:
            "Você perderá os dados que já preencheu caso não tenha salvo, deseja realmente voltar?",
          action: "setModalCadastroProduto",
          action_value: false,
        });
      }
    },
  },
  mounted() {
    this.listarMarcas();
    this.listarUnidades();
    this.listarGruposProduto();
    this.listarSecoesProduto();
    this.listarCST();
    this.listarFabricantes();
  },
};
</script>
